import gsap from "gsap";
import { getCart } from "../helpers";
const SECTION_NAME = "notification";

/* @param {HTMLElement} baseElement */
/* export function init(baseElement) {
  if (baseElement) {
    const notificationContainerOverlay = document.querySelector(
      ".notification-container-overlay"
    );
  }
} */

export function notification() {
  const notificationContainerOverlay = document.querySelector(
    ".notification-container-overlay"
  );
  const notificationInner = document.querySelector(
    ".notification-container-inner"
  );
  const notificationMessageElement = document.querySelector(
    ".notification-message"
  );
  const notificationActionElement = document.querySelector(
    ".notification-action"
  );

  let tl = gsap
    .timeline({
      paused: true,
      onReverseComplete: () => {
        notificationMessageElement.innerHTML = "";
        notificationActionElement.classList.add("is-hidden");
      },
    })
    .set(notificationContainerOverlay, { height: "100%", opacity: 0 })
    .set(notificationInner, { yPercent: -100 })
    .to(notificationContainerOverlay, {
      opacity: 1,
      duration: 0.5,
    })
    .to(notificationInner, {
      yPercent: 0,
      duration: 0.5,
      ease: "expo",
    });

  async function showNotificaiton(type, message) {
    if (type == "error") {
      notificationMessageElement.innerHTML = message.replace("cart", "bag");
      // TODO later: add logic to change the action
      notificationActionElement.classList.add("is-hidden");
    } else if (type == "success") {
      // TODO later: make it reusable (see mini-cart.js also)
      let cart;
      try {
        cart = await getCart();
        if (typeof cart !== "object") return;
        const itemCount = cart["item_count"];
        notificationMessageElement.innerHTML = /* html */ `<span>${message}</span><span>Bag ${
          itemCount === 0 ? "" : `(${itemCount})`
        }</span>`;
        notificationActionElement.classList.remove("is-hidden");
      } catch (err) {
        console.error(err);
      }
    }

    tl.play();
    notificationContainerOverlay.addEventListener("click", (e) => {
      // @ts-ignore
      if (e.target.id == "notification-container-overlay") {
        hideNotification();
      }
    });
  }

  function hideNotification() {
    tl.reverse();
  }

  return {
    show: showNotificaiton,
    hide: hideNotification,
  };
}
